<template>
	<div>
		<el-select
			v-model="myValue"
			value-key="_id"
			size="mini"
			:clearable="true"
			placeholder="选择系统仓库"
			@change="handleChange"
			:loading="loading"
		>
			<el-option label="全部" :value="''"></el-option>
			<el-option v-for="item in warehouses" :key="item._id" :label="item.name" :value="item"></el-option>
		</el-select>
	</div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
	data() {
		return {
			id: "",
			loading: false,
			myValue: {
				name: "",
				_id: ""
			}
		};
	},
	props: {
		dataModel: {
			type: String,
			default: "warehouse"
		},
		nameFields: {
			type: Array,
			default: () => {
				return ["name"];
			}
		},
		value: {
			type: Object,
			default: () => {
				return {
					_id: "",
					name: ""
				};
			}
		},
		hasAll: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapState(["warehouses"])
	},
	created() {},
	mounted() {
		if (typeof this.value === "string") {
			this.value = {
				_id: this.value,
				name: ""
			};
		}
		this.resetEditor(this.value);
		this.getWarehouses(true);
	},
	methods: {
		...mapMutations(["getWarehouses"]),
		resetEditor(val) {
			this.id = val._id;
			for (let k in val) {
				this.$set(this.myValue, k, val[k]);
			}
		},
		handleChange(val) {
			console.log("CHANGED", typeof val);
			console.log("myValue", this.myValue);

			if (typeof val == "object") {
				this.$emit("input", this.myValue);
				this.$emit("change", this.myValue);
				return;
			}
			if (val === "") {
				//清空
				this.myValue = {
					_id: "",
					name: ""
				};
				this.$emit("input", this.myValue);
				this.$emit("change", this.myValue);
				return;
			}
			//新建

			this.myValue = {
				name: val,
				_id: ""
			};
			this.$confirm("确认创建" + this.myValue.name + "?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.loading = true;
					this.$axios
						.post("/curd/do_quick_create/" + this.dataModel, {
							name: this.myValue.name
						})
						.then(json => {
							this.loading = false;
							this.$message({
								type: "success",
								message: "创建成功!"
							});
							this.options.push(json.data.info);
							this.$nextTick(() => {
								for (let k in json.data.info) {
									this.$set(this.myValue, k, json.data.info[k]);
								}
								this.$emit("input", this.myValue);
								this.$emit("change", this.myValue);
							});
						})
						.catch(json => {
							this.loading = false;
							this.$message.error(json.data.msg);
						});
				})
				.catch(() => {
					this.myValue = {
						_id: "",
						name: ""
					};
					this.$message({
						type: "info",
						message: "已取消"
					});
				});
		}
	},
	components: {}
};
</script>
<style lang="scss" scoped>
</style>
